import { Flex, Typography } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { useTheme } from "styled-components";
import {
  StyledAuthContainer,
  StyledAuthContent,
  StyledAuthLogoWrapper,
  StyledAuthFooter,
} from "./index.styled";
import DecorativeBlobsBg from "./DecorativeBlobsBg";
import { ReactComponent as EmpireFxLogoLight } from "_assets/images/logos/empirefx-logo-light-theme.svg";
import { ReactComponent as EmpireFxLogoDark } from "_assets/images/logos/empirefx-logo-dark-theme.svg";

const AuthContainer = (props) => {
  const {
    title,
    subtitle,
    subtitleLink,
    subtitleLinkText,
    subtitleLinkPrefix,
    children,
    footerText,
  } = props;
  const theme = useTheme();
  const isDark = theme.palette.background.auth === "#16283A";
  const EmpireFxLogo = isDark ? EmpireFxLogoDark : EmpireFxLogoLight;
  const accentColor = isDark ? "#AAB0FF" : "#5f5fff";

  return (
    <StyledAuthContainer vertical>
      <DecorativeBlobsBg />
      <StyledAuthLogoWrapper>
        <EmpireFxLogo style={{ width: 152, height: 32 }} />
      </StyledAuthLogoWrapper>
      <StyledAuthContent vertical gap={20}>
        <Flex vertical gap={8}>
          <Title level={3}>{title}</Title>
          {subtitle && (
            <Text
              type="secondary"
              style={{
                fontSize: 14,
                lineHeight: "20px",
                color: isDark ? theme.palette.text.authLabel : "#6f7285",
              }}
            >
              {subtitle}
            </Text>
          )}
        </Flex>

        {children}

        {subtitleLink && (
          <Flex justify="center" gap={4} style={{ marginTop: 8 }}>
            <Text style={{ fontSize: 12, color: isDark ? theme.palette.text.authLabel : "#6f7285" }}>
              {subtitleLinkPrefix || "Already have an account?"}
            </Text>
            <Link
              to={subtitleLink}
              style={{ fontSize: 12, fontWeight: 500, color: accentColor }}
            >
              {subtitleLinkText}
            </Link>
          </Flex>
        )}
      </StyledAuthContent>
      {footerText && (
        <StyledAuthFooter>
          <Text style={{ fontSize: 14, color: "#6a708f" }}>
            {footerText}
          </Text>
        </StyledAuthFooter>
      )}
    </StyledAuthContainer>
  );
};

const { Title, Text } = Typography;

AuthContainer.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  subtitleLink: PropTypes.string,
  subtitleLinkText: PropTypes.string,
  subtitleLinkPrefix: PropTypes.string,
  children: PropTypes.node.isRequired,
  footerText: PropTypes.string,
};

export default AuthContainer;
